import React from 'react';
import './LoadingOverlay.css';

interface LoadingOverlayProps {
  visible?: boolean;
  title?: string;
  detail?: string;
}

export default function LoadingOverlay({ visible = true, title = 'Procesando…', detail }: LoadingOverlayProps): React.ReactElement | null {
  if (!visible) return null;
  return (
    <div className="loading-overlay" role="status" aria-live="assertive">
      <div className="loading-dialog">
        <div className="brand-loader"><span /><span /><span /></div>
        <strong>{title}</strong>
        {detail && <p>{detail}</p>}
      </div>
    </div>
  );
}
